import React, { useState } from 'react';
import { Navigate } from 'react-router';
import { Loader } from '../../components/Loader';
import { SubscriptionPlanSelector } from '../../components/SubscriptionPlanSelector';
import { GuaranteeBlock } from '../../components/GuaranteeBlock';
import { SkillList } from '../../components/SkillList';
import { useSubscriptionPlans } from '../../shared/use-subscription-plans';
import { useUser } from '../../shared/use-user';
import { createSubscription } from '../../../lib/use-cases/create-subscription';
import { pagePathnames } from '../page-routes';
import { MONTHLY_1999_WITHOUT_TRIAL_PLAN } from '../../../lib/shared/subscription-plans';
import premiumDesktopImageSrc from '../../assets/images/page/premium-desktop.png';
import premiumMobileImageSrc from '../../assets/images/page/premium-mobile.png';
import styles from './PremiumPage.css';

function PremiumPage() {
    const {userData, isLoading: isLoadingUserData} = useUser();
    const {plans, isLoading} = useSubscriptionPlans();
    const [isPending, setIsPending] = useState(false);

    if (!isLoadingUserData && userData.isActiveSubscription) {
        return <Navigate to={pagePathnames.main} replace />;
    };

    const submitSubscription = async subscriptionData => {
        try {
            setIsPending(true);

            const newOrder = await createSubscription({
                plan: subscriptionData.plan,
                email: userData.email
            });

            if (newOrder.paymentUrl) {
                window.location.href = newOrder.paymentUrl;
            }
        } catch (e) {
            alert(e.message || 'Failed create subscription');
        } finally {
            setIsPending(false);
        }
    };

    const renderContent = () => {
        if (isLoading) {
            return (
                <div className={styles.loaderWrapper}>
                    <Loader variant='secondary' />
                </div>
            );
        };

        return (
            <>
                <SubscriptionPlanSelector
                    onSubmit={submitSubscription}
                    defaultPlan={MONTHLY_1999_WITHOUT_TRIAL_PLAN}
                    isPending={isPending}
                    plans={plans}
                    className={styles.subscriptionPlanSelector}
                />
                <h2 className={styles.secondaryTitle}>100% protection uptime:</h2>
                <SkillList className={styles.blockWithIndent} />
                <GuaranteeBlock className={styles.guaranteeBlock} />
            </>
        )
    };

    return (
        <div className={styles.root}>
            <div className={styles.contentHeader}>
                <h1 className={styles.title}>Get Your Emergency Data Protection Plan</h1>
                <div
                    className={styles.bgImage}
                    style={{
                        ['--desktop-bg-image-url']: `url(${premiumDesktopImageSrc}`,
                        ['--mobile-bg-image-url']: `url(${premiumMobileImageSrc}`,
                    }}
                />
            </div>
            {renderContent()}
        </div>
    )
};

export {
    PremiumPage
};
